"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const am4core = __importStar(require("@amcharts/amcharts4/core"));
const am4charts = __importStar(require("@amcharts/amcharts4/charts"));
const styles_1 = require("@mui/material/styles");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const useXYChart_1 = __importDefault(require("hooks/useXYChart"));
const state_1 = require("../../state");
const NetIncomeChart = (0, react_1.forwardRef)(({ data, height, shading, onCategorySelect, fallbackSelect, showScrollBar, noOfMonths, setShowClearButton, resetTransactionRegister, }, ref) => {
    const { state } = react_1.default.useContext(state_1.ReportsStateContext);
    const { selectedGraphCategory, selectedReportTableCell, clearGraphSelection } = state;
    const { chart, xAxis, yAxis, makeSelectionStates, createCategoryRange, buildTooltipOn, buildTooltipSeriesInfo, buildLegend, } = (0, useXYChart_1.default)('net-income-chart-div', null, showScrollBar, noOfMonths, true);
    const theme = (0, styles_1.useTheme)();
    const handleBarChartDeselect = () => {
        if (!chart || chart.isDisposed()) {
            return;
        }
        chart.series.each((series) => {
            var _a;
            (_a = (series.columns || series.segments)) === null || _a === void 0 ? void 0 : _a.each((paramItem) => {
                const item = paramItem;
                item.setState('default');
                item.isActive = false;
                item.tooltip.hide();
            });
        });
        if (!selectedReportTableCell) {
            setShowClearButton(false);
        }
    };
    const handleCategoryClick = (0, react_1.useCallback)((e, forceSelect = false) => {
        var _a, _b, _c, _d;
        const clickedCat = ((_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.dataItem) === null || _b === void 0 ? void 0 : _b.category) || ((_d = (_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.dataItem) === null || _d === void 0 ? void 0 : _d.categoryX) || e;
        if (!clickedCat || typeof clickedCat !== 'string' || !chart)
            return;
        let selectedCat = null;
        chart.series.each((ser) => {
            var _a;
            return (_a = (ser.columns || ser.segments)) === null || _a === void 0 ? void 0 : _a.each((col) => {
                if (selectedCat)
                    return;
                if (col.isActive) {
                    selectedCat = col.dataItem.categoryX;
                }
            });
        });
        if (clickedCat === selectedCat && !forceSelect) { // deselecting
            chart.series.each((series) => {
                var _a;
                (_a = (series.columns || series.segments)) === null || _a === void 0 ? void 0 : _a.each((paramItem) => {
                    const item = paramItem; // for es-lint
                    item.setState('default');
                    item.isActive = false;
                    item.tooltip.hide();
                    setShowClearButton(false);
                });
            });
        }
        else { // selecting
            chart.series.each((series) => {
                var _a;
                (_a = (series.columns || series.segments)) === null || _a === void 0 ? void 0 : _a.each((paramItem) => {
                    const item = paramItem; // for es-lint
                    if (item.dataItem.categoryX !== clickedCat) {
                        item.tooltip.hide();
                        item.isActive = false;
                        setShowClearButton(true);
                    }
                    item.setState((item.dataItem.categoryX === clickedCat) ? 'active' : 'inactive');
                });
            });
        }
        onCategorySelect(clickedCat === selectedCat && !forceSelect ? null : clickedCat);
    }, [chart, onCategorySelect, setShowClearButton]);
    const checkForFallbackSelect = (0, react_1.useCallback)(() => {
        if (fallbackSelect && fallbackSelect.current) {
            handleCategoryClick(fallbackSelect.current, true);
        }
    }, [fallbackSelect, handleCategoryClick]);
    const createBarSeries = (0, react_1.useCallback)((field, name, color) => {
        const series = chart.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = 'category';
        series.showOnInit = false;
        series.columns.template.width = am4core.percent(100);
        series.columns.template.spacing = 100;
        series.columns.template.cellStartLocation = 0;
        series.columns.template.cellEndLocation = 1;
        series.columns.template.column.zIndex = 2;
        series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        series.columns.template.tooltipY = 0;
        series.columns.template.fill = color;
        series.columns.template.stroke = color;
        series.fill = color;
        const cornerRadius = (sign) => (radius, item) => Math.sign(item.dataItem.dataContext[series.dataFields.valueY]) === sign ? 4 : radius;
        series.columns.template.column.adapter.add('cornerRadiusTopLeft', cornerRadius(1));
        series.columns.template.column.adapter.add('cornerRadiusTopRight', cornerRadius(1));
        series.columns.template.column.adapter.add('cornerRadiusBottomLeft', cornerRadius(-1));
        series.columns.template.column.adapter.add('cornerRadiusBottomRight', cornerRadius(-1));
        series.columns.template.events.on('hit', handleCategoryClick);
        series.events.on('ready', checkForFallbackSelect);
        makeSelectionStates(series.columns.template, color);
        return series;
    }, [chart, makeSelectionStates, checkForFallbackSelect, handleCategoryClick]);
    (0, react_1.useLayoutEffect)(() => {
        var _a;
        if (chart && !chart.isDisposed()) { // this is where to set up chart specific stuff
            (_a = chart === null || chart === void 0 ? void 0 : chart.series) === null || _a === void 0 ? void 0 : _a.clear();
            chart.invalidateData();
            const incomeSeries = createBarSeries('incomeTotal', 'Income', am4core.color(theme.components.report.positiveDefault));
            const spendingSeries = createBarSeries('spendingTotal', 'Expense', am4core.color(theme.components.report.negativeDefault));
            // handles clicking the category labels to put the other bars in an unselected state
            xAxis.renderer.labels.template.events.on('hit', handleCategoryClick);
            xAxis.axisRanges.clear();
            yAxis.min = 0;
            if (data === null || data === void 0 ? void 0 : data.some((val) => val.netIncomeTotal < 0)) {
                yAxis.extraMin = 0.1;
            }
            data.forEach(({ category }) => {
                const catRange = createCategoryRange(category);
                catRange.axisFill.events.on('hit', handleCategoryClick);
                catRange.axisFill.cursorOverStyle = am4core.MouseCursorStyle.pointer;
            });
            buildTooltipOn(incomeSeries);
            incomeSeries.tooltip.background.pointerLength = 12;
            incomeSeries.tooltipHTML = `<div style="color: ${theme.palette.text.secondary};border-radius: ${theme.shape.borderRadius * 2}px;padding: ${theme.shape.padding[2]}px;" >
        ${buildTooltipSeriesInfo(incomeSeries)}
        ${buildTooltipSeriesInfo(spendingSeries)}
        <div style="width: 100%:height: 2px;border-bottom-width: 1px;border-bottom-style: solid;border-bottom-color: ${theme.palette.grey.level3};margin: 5px 0px;"></div>
        <div style="color: ${theme.components.tooltip.primaryTextColor};font-size: 14px;background-color: inherit;display: flex;align-items: center;justify-content: space-between" >
            <span>Net Income</span>
            <span id="tooltip_total_amount" >{totalValues.sign}\${totalValues.value}</span>
        </div>`;
            chart.numberFormatter.numberFormat = '#,###.00';
            chart.data = data;
            buildLegend();
            chart.legend.itemContainers.template.paddingTop = 20;
            chart.legend.itemContainers.template.paddingBottom = 20;
        }
    }, [
        shading,
        createBarSeries,
        chart,
        createCategoryRange,
        buildTooltipOn,
        buildTooltipSeriesInfo,
        buildLegend,
        theme,
        xAxis,
        data,
        yAxis,
        handleCategoryClick,
    ]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        getGraphImage() {
            var _a;
            return (_a = chart === null || chart === void 0 ? void 0 : chart.exporting) === null || _a === void 0 ? void 0 : _a.getImage('png', { quality: 1, scale: 3 });
        },
    }));
    (0, react_1.useEffect)(() => {
        if (!clearGraphSelection) {
            return;
        }
        handleBarChartDeselect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearGraphSelection]);
    // It clears the bar chart selection on clicking the chart surrounding area.
    document.addEventListener('click', (event) => {
        if (!selectedGraphCategory) {
            return;
        }
        const target = event.target;
        const whitelistedTargetIds = ['graph-header-container', 'chart-container', 'net-income-chart-div', 'report-container', 'report-heading'];
        // Check if the clicked target is in whitelisted HTML elements or inside the chart
        if (whitelistedTargetIds.includes(target.id)) {
            handleBarChartDeselect();
            resetTransactionRegister();
        }
    });
    const divStyle = (0, react_1.useMemo)(() => ({ width: '100%', height: height || 400 }), [height]);
    return (<>
      <RendersCount_1.default id="newReportsNetIncomeChart"/>
      <div id={'net-income-chart-div'} style={divStyle}/>
    </>);
});
exports.default = NetIncomeChart;
